import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(VHover, {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var hover = ref.hover
          return [
            _c(
              VCard,
              {
                class: "alert-inca rounded-xl " + (hover ? "hover-alert" : ""),
                attrs: { "min-width": "350", role: _vm.liveRole },
              },
              [
                _c(VCardText, { staticClass: "p-0" }, [
                  _c(
                    "div",
                    { class: "header-alert " + _vm.color },
                    [
                      _c(
                        "span",
                        { staticClass: "vertical-center circle1" },
                        [
                          _c(
                            VIcon,
                            {
                              staticClass: "vertical-center",
                              attrs: { color: "white" },
                            },
                            [_vm._v(_vm._s(_vm.icon))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VIcon,
                        {
                          staticClass: "close",
                          attrs: { "aria-label": _vm.$t("btns.close") },
                          on: { click: _vm.onClose },
                        },
                        [_vm._v("icon-decline")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "header-body p-4 text-center",
                      staticStyle: {
                        "max-height": "500px",
                        "overflow-y": "scroll",
                      },
                    },
                    [
                      _c("h5", { class: _vm.color + "--text" }, [
                        _vm._v("¡" + _vm._s(_vm.title) + "!"),
                      ]),
                      _c("div", {
                        staticClass: "pb-0",
                        domProps: { innerHTML: _vm._s(_vm.subtitle) },
                      }),
                      _vm.path != ""
                        ? _c(
                            "div",
                            [
                              _c(
                                VBtn,
                                {
                                  attrs: {
                                    dense: "",
                                    outlined: "",
                                    rounded: "",
                                    small: "",
                                  },
                                  on: { click: _vm.onContinuar },
                                },
                                [
                                  _vm._v(" Continuar "),
                                  _c(VIcon, [_vm._v("mdi-arrow-right")]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.list_path && _vm.list_path.length > 0
                        ? _c(
                            "div",
                            { staticStyle: { display: "inline-grid" } },
                            _vm._l(_vm.list_path, function (item) {
                              return _c(
                                VBtn,
                                {
                                  staticClass: "mb-1",
                                  attrs: {
                                    dense: "",
                                    outlined: "",
                                    rounded: "",
                                    small: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onVerItem(item)
                                    },
                                  },
                                },
                                [
                                  _vm._v(" " + _vm._s(item.name) + " "),
                                  _c(VIcon, [_vm._v("mdi-arrow-right")]),
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }